/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import { autoDetect as autoDetectLocale } from "../util/locale";

export default {
  namespaced: true,
  state: {
    locale: autoDetectLocale()
  },
  getters: {
    locale: state => state.locale
  },
  mutations: {},
  actions: {}
};
